(() => {
  'use strict';
  const money=BundleCatalogue.money;
  function create(){
    const cart=BundleCart.create();
    const dialog=document.getElementById('hywell-bundle-cart-drawer');
    const content=document.getElementById('cart-bundles');
    const getProduct=id=>BundleCatalogue.products.find(product=>product.id===id);
    function render(){
      const {groups,quote}=cart.snapshot();
      document.getElementById('bag-count').textContent=quote.quantity;
      document.getElementById('bag-count').classList.toggle('t4s-op-0',!quote.quantity);
      document.getElementById('cart-count').textContent=quote.quantity;
      document.getElementById('cart-discount').textContent=quote.quantity?`${quote.discountPercent}% off${quote.discountPercent?' unlocked!':''}`:'Build your first bundle';
      document.getElementById('cart-progress-bar').style.width=Math.min(100,quote.quantity/10*100)+'%';
      dialog.querySelectorAll('[data-cart-tier]').forEach(element=>element.classList.toggle('is-unlocked',quote.quantity>=Number(element.dataset.cartTier)));
      document.getElementById('cart-next-tier').textContent=quote.nextTier?`Add ${quote.nextTier.quantity-quote.quantity} more ${quote.nextTier.quantity-quote.quantity===1?'pair':'pairs'} to unlock ${quote.nextTier.percent}% off.`:'You unlocked our best bundle price.';
      let lineIndex=0;
      content.innerHTML=groups.length?groups.map(group=>`<section class="cart-bundle" data-cart-group="${group.key}"><div class="cart-bundle-heading"><h3>${group.name}</h3><button type="button" class="cart-remove" data-cart-remove="${group.key}" aria-label="Remove ${group.name}">Remove bundle</button></div>${group.lines.map(line=>{
        const product=getProduct(line.id),total=quote.lineTotals[lineIndex++],regular=line.price*line.quantity;
        const colorChoice=group.id==='winter'?`<label class="cart-size-label cart-color-label">Color<select data-cart-color="${line.id}" data-cart-group="${group.key}" aria-label="${group.name} ${product.name} color">${product.colors.map(color=>`<option${color===line.color?' selected':''}>${color}</option>`).join('')}</select></label>`:'';
        return `<article class="cart-product"><img src="${window.HywellBundleAssets['products/'+product.images[line.color]+'.jpg']}" width="76" height="92" alt="${line.color} ${product.name} socks"><div class="cart-product-info"><h4>Merino Wool ${product.name} Socks</h4><p class="cart-fixed-details">${line.color} <span aria-hidden="true">·</span> ${line.quantity} ${line.quantity===1?'pair':'pairs'}</p><div class="cart-variant-options${colorChoice?' has-color':''}"><label class="cart-size-label">Size<select data-cart-size="${line.id}" data-cart-group="${group.key}" aria-label="${group.name} ${product.name} size">${['M','L','XL'].map(size=>`<option${size===line.size?' selected':''}>${size}</option>`).join('')}</select></label>${colorChoice}</div></div><div class="cart-line-price"><del>${money(regular)}</del><strong>${money(total)}</strong><small>Save ${money(regular-total)}</small></div></article>`;
      }).join('')}</section>`).join(''):'<div class="cart-empty"><h3>Your cart is waiting.</h3><p>Pick a bundle to get started.</p></div>';
      document.getElementById('cart-savings').textContent=`−${money(quote.savings)}`;
      document.getElementById('cart-savings-label').textContent=`Bundle savings (${quote.discountPercent}%)`;
      document.getElementById('cart-subtotal').textContent=money(quote.total);
      document.getElementById('cart-checkout').textContent=quote.quantity?`Checkout · ${money(quote.total)}`:'Checkout';
      document.getElementById('cart-checkout').disabled=!quote.quantity;
      dialog.querySelector('.cart-preview-note').textContent='Shipping and taxes are calculated at checkout.';
      document.getElementById('cart-footer-prices').hidden=!quote.quantity;
    }
    function open(){render();if(!dialog.open)dialog.showModal();document.body.classList.add('cart-is-open');}
    dialog.addEventListener('close',()=>document.body.classList.remove('cart-is-open'));
    dialog.querySelector('[data-cart-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-cart-continue]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-cart-builder]').addEventListener('click',()=>{
      dialog.close();
      if(dialog.querySelector('[data-cart-builder]').getAttribute('href')==='#builder')document.getElementById('builder').scrollIntoView({block:'start'});
    });
    content.addEventListener('change',event=>{
      const select=event.target;
      if(select.matches('[data-cart-size]')){
        cart.setSize(Number(select.dataset.cartGroup),select.dataset.cartSize,select.value);
      }else if(select.matches('[data-cart-color]')){
        cart.setColor(Number(select.dataset.cartGroup),select.dataset.cartColor,select.value);
        const product=getProduct(select.dataset.cartColor),row=select.closest('.cart-product');
        row.querySelector('img').src=window.HywellBundleAssets['products/'+product.images[select.value]+'.jpg'];
        row.querySelector('img').alt=`${select.value} ${product.name} socks`;
        row.querySelector('.cart-fixed-details').firstChild.textContent=select.value+' ';
        document.getElementById('live-status').textContent=`${product.name} color changed to ${select.value}.`;
      }
      // Variants do not change prices; update in place to retain focus and scroll.
    });
    content.addEventListener('click',event=>{
      const button=event.target.closest('[data-cart-remove]');
      if(!button)return;
      cart.removeBundle(Number(button.dataset.cartRemove));render();
      const next=content.querySelector('select,button')||dialog.querySelector('[data-cart-close]');
      next.focus({preventScroll:true});
    });
    const headerButton=document.getElementById('bag-button');
    function openFromHeader(event){
      event.preventDefault();event.stopImmediatePropagation();open();
    }
    window.HywellBundleCartHeaderCleanup?.();
    headerButton.addEventListener('click',openFromHeader,true);
    window.HywellBundleCartHeaderCleanup=()=>headerButton.removeEventListener('click',openFromHeader,true);
    document.getElementById('cart-checkout').addEventListener('click',()=>{
      const button=document.getElementById('cart-checkout');
      try{
        button.disabled=true;
        button.textContent='Opening checkout…';
        if(BundleCatalogue.openCheckout(cart.snapshot().groups.flatMap(group=>group.lines))==='new-tab'){
          button.disabled=false;
          button.textContent=`Checkout · ${money(cart.snapshot().quote.total)}`;
        }
      }catch(error){
        const note=dialog.querySelector('.cart-preview-note');
        note.textContent=error.message;
        note.setAttribute('role','alert');
        button.disabled=false;
      }
    });
    render();
    return {addBundle(id){cart.addBundle(id);open();document.getElementById('live-status').textContent='Bundle added to your cart. Choose your sizes.';}};
  }
  window.BundleCartDrawer={create};
})();
